export const appStoreUrl =
  "https://apps.apple.com/vn/app/vev%C3%A9/id6474672806";
export const chPlayUrl =
  "https://play.google.com/store/apps/details?id=com.veve.client&pcampaignid=web_share";
